const tabs = document.querySelectorAll('[role="tab"]')
const tabPanels = document.querySelectorAll('[role="tabpanel"]')

tabs.forEach((tab, index) => {
  tab.addEventListener('click', function(e) {
    e.preventDefault()
    removeActiveStates(tabs, tabPanels)
    addActiveState(tab, tabPanels[index])
  })
})

const removeActiveStates = (tabs, tabPanels) => {
  tabs.forEach(tab => {
    tab.classList.remove('--is-active')

    tabPanels.forEach(panel => {
      panel.classList.add('+display-none')
    })
  })
}

const addActiveState = (tab, tabPanel) => {
  tab.classList.add('--is-active')
  tabPanel.classList.remove('+display-none')
}
